module.exports = __webpack_public_path__ + "static/media/_MIC2505.image.ed130350.png";